<template>
  <customModal
    :containermd="true"
    @closeModal="handleClose"
  >
    <template #title>
      <span v-if="documentEdit === false">{{ $t('navigations.upload document') }}</span>
      <span v-else>{{ $t('navigations.edit document') }}</span>
    </template>

    <template #body>
      <!-- Loader only in edit mode when fetching doc -->
      <div class="text-center" v-if="documentEdit && documentLoader">
        <h4>{{ 'Please wait while the data is being fetched' }}</h4>
        <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
      </div>

      <div v-else>
        <div class="row">
          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="document-title">Document Title</label>
            <input
              id="document-title"
              type="text"
              class="form-control"
              maxlength="75"
              v-model.trim="docTitle"
              :disabled="true"

            />
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="version">Version <sup><i class="fa fa-asterisk required"></i></sup></label>
            <input
              id="version"
              type="text"
              class="form-control"
              maxlength="10"
              v-model.trim="docVersion"
              :readonly="documentEdit === true"
              placeholder="Enter version"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[0]">
              Please enter a version
            </span>
          </div>

          <div class="col-12 col-md-6 pr-md-1 mt-2">
            <label for="documentOwner">Select Owner</label>
            <select
              id="documentOwner"
              v-model="documentUploadFields.owner"
              class="form-select form-select-lg"
            >
             <option value="" disabled>Select Owner</option>
              <option
                v-for="(u, idx) in ownerList"
                :key="idx"
                :value="`${u.firstName} ${u.lastName}`"
              >
                {{ `${u.firstName} ${u.lastName}` }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Expiry Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.expiryDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[1]">
              Please enter a future date
            </span>
          </div>
          <div class="col-12 col-md-6 mt-2">
            <label for="expiry-date">Expected Completion Date</label>
            <input
              id="expiry-date"
              type="text"
              class="form-control"
              v-model="documentUploadFields.ExpectedCompletionDate"
              onfocus="(this.type='date')"
              onblur="(this.type='text')"
              placeholder="Select a date"
              maxlength="30"
            />
            <span class="d-block errorClass" v-if="documentValidationsError[3]">
              Please enter a future date
            </span>
          </div>

          <div class="col-12 mt-2">
            <label for="description">Description</label>
            <textarea
              id="description"
              class="form-control"
              maxlength="250"
              v-model.trim="documentUploadFields.description"
              :disabled="true"
            ></textarea>
          </div>

          <div class="col-12 mt-2">
            <label for="changesHistory">Changes History</label>
            <textarea
              id="changesHistory"
              class="form-control"
              maxlength="250"
              v-model.trim="documentUploadFields.changesHistory"
              placeholder="Enter changes history"
            ></textarea>
          </div>

          <div class="col-12 mt-2">
            <input
              ref="fileInput"
              id="upload-file-input"
              type="file"
              class="form-control d-none my-2 my-md-0"
              accept=".xls,.xlsx,.jpg,.jpeg,.png,.pdf,.docx,.doc"
              @change="previewFiles"
              multiple
            />
            <div
              v-for="(f, idx) in list"
              :key="`${f.name}-${idx}`"
              class="input-group"
            >
              <div class="listfile breakWord">
                <a>
                  {{ f.name }}
                  <i class="fa fa-close" @click.prevent="removefile(idx)"></i>
                </a>
              </div>
            </div>
            <span class="errorClass" v-if="documentValidationsError[2]">
              Please upload a file
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="d-flex justify-content-end mt-2">
          <button class="browser-btn py-1 px-3 mr-2" type="button" @click="browse">
            <p class="mb-0">{{ $t('navigations.browse') }}</p>
          </button>

          <button
            type="button"
            class="save_btn py-1 px-3 position-relative"
            :disabled="loadingDocUpload"
            :class="{ 'disabled-btn-cls': loadingDocUpload }"
            @click="submitFile"
          >
            <div
              class="toc-loader position-absolute"
              :class="{ 'opacity-0': !loadingDocUpload, 'opacity-1': loadingDocUpload }"
            >
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
            </div>
            <p class="mb-0" :class="{ 'opacity-1': !loadingDocUpload, 'opacity-0': loadingDocUpload }">
              {{ $t('navigations.save') }}
            </p>
          </button>
        </div>
      </div>
    </template>
  </customModal>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import store from '../../store'
import customModal from '../customModal/customModal.vue'
import jwt_decode from "jwt-decode";

export default {
  name: 'UploadDocumentModal',
  components: { customModal },

  props: {
    docid:{type: String, default: '' },
    visible: { type: Boolean, default: false },
    documentEdit: { type: Boolean, default: false },
    selectedDocument: { type: String, default: '' },
    currentUser: { type: String, default: '' },
    version: { type: [String, Number], default: '' },
    documentTitle: { type: String, default: '' },
    description: { type: String, default: '' },
    siteCode: {
      type: String,
      default: "",
    },
  },

  data () {
    return {
      // local state
      siteid:"",
      ownerList: [],
      createdfolderid:"",
      documentUploadFields: {
        expiryDate: '',
        description: '',
        changesHistory: '',
        owner: '',
        ExpectedCompletionDate: ''
      },
      list: [],
      azuredata: { Document: [] },
      documentValidationsError: [false, false, false],
      docTitle: '',
      docVersion: '',
      loadingDocUpload: false,
      documentLoader: false,
      baseurl: process.env.VUE_APP_Service_URL,
      selectedArtifact:"",
      Artifacts:[],
      currentUser: "",
    }
  },
async mounted() {
  this.docTitle=this.documentTitle;
  this.documentUploadFields.description=this.description;
  console.log("description",this.description);
    this.getsiteid();
   this.getArtifacts();
   this.fetchDocumentDetails();
   this.getStudyBasedUsers();
    //this.getreviewers();
  },
  watch: {
    // Reset every time modal opens
    visible (val) {
      if (val) {
        this.resetLocal()
        // default owner if empty
        if (!this.documentUploadFields.owner && this.currentUser) {
          this.documentUploadFields.owner = this.currentUser
        }
       
      }
    },
  },

  methods: {
    handleClose () {
      this.$emit('uploadlibactive')
      this.resetLocal()
    },
   async getStudyBasedUsers(type) {
  const idtoken = store.getters.getIdToken;
  try {
    const res = await axios.get(
      `${this.baseurl}/account-core/user/getstudybasedusers?studyid=${store.getters.getStudyIs}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data?.entities?.length) {
      this.ownerList = res.data.entities.sort((a, b) =>
        a.firstName.localeCompare(b.firstName)
      );
      await this.setCurrentUser(this.ownerList);
    } else {
      console.warn("No users returned for this study.");
      this.ownerList = [];
      this.currentUser = null;
    }
  } catch (err) {
    console.error("Error fetching study-based users:", err);
  }
},
   async setCurrentUser(data) {
      console.log("logged", data);
      const idtoken = store.getters.getIdToken;
      const userEmail = jwt_decode(idtoken).email.trim();

      const userObject = data.find((item) => item.email?.trim() === userEmail);

      if (userObject) {
        this.currentUser = `${userObject.firstName} ${userObject.lastName}`;
        console.log("current user = ", this.currentUser);
       this.documentUploadFields.owner = this.currentUser;
      } else {
        console.warn(`No user found for email: ${userEmail}`);
        this.currentUser = null; 
      }
    },
    async getsiteid(){
 const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

        await axios
                    .get(`${this.baseurl}/management/site/getall?studyId=${studyId}`,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            }
                        })
                    .then((res) => {
                       const found = res.data.find((element) => element.siteCode == this.siteCode );
                       this.siteid = found.siteID;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
    },
    resetLocal () {
      this.documentUploadFields = {
        expiryDate: '',
        description: '',
        changesHistory: '',
        owner: this.currentUser || '',
        ExpectedCompletionDate: ''
      }
      this.docTitle = ''
      this.docVersion = ''
      this.azuredata.Document = []
      this.list = []
      this.documentValidationsError = [false, false, false]
      this.loadingDocUpload = false
      this.documentLoader = false
    },

    browse () {
      this.$refs.fileInput && this.$refs.fileInput.click()
    },

    previewFiles (e) {
      this.azuredata.Document = []
      this.azuredata.Document.push(e.target.files)
      this.list = [...this.list, ...this.azuredata.Document[0]]
    },

    removefile (idx) {
      this.list.splice(idx, 1)
    },

    async validatedocument() {
      this.documentValidationsError = [false, false, false];

      // if (store.getters.getFolderId.trim() == "") {
      //   this.documentValidationsError[0] = true;
      //   this.loadingDocUpload = false
      // }
      
      if (this.docVersion.trim() == "") {
        this.documentValidationsError[0] = true;
        this.loadingDocUpload = false
      }
      if (this.azuredata.Document.length === 0 && this.documentEdit == false) {
        this.documentValidationsError[2] = true;
        this.loadingDocUpload = false
      }
      
      if (this.documentUploadFields.expiryDate != null) {
        if (new Date(this.documentUploadFields.expiryDate) < new Date()) {
          this.documentValidationsError[1] = true;
          this.loadingDocUpload = false
        }
      }
      if (this.documentUploadFields.ExpectedCompletionDate != null) {
        if (new Date(this.documentUploadFields.ExpectedCompletionDate) < new Date()) {
          this.documentValidationsError[3] = true;
          this.loadingDocUpload = false
        }
      }

    },
     async getArtifacts() {
      const idtoken = store.getters.getIdToken;
      let studyId = store.getters.getStudyIs;

      await axios
        .get(
          `${this.baseurl}/etmf/folder/getartifact?studyId=${studyId}&zoneName=""`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.Artifacts = res.data;
          if (this.artifactId) {
            const found = this.Artifacts.find(
              (a) => a.artifactId === this.artifactId
            );
            if (found) {
              this.selectedArtifact = found.artifactId;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async submitFile() {
      const folderId = this.createdfolderid;
      const idtoken = store.getters.getIdToken;
      this.loadingDocUpload = true
      let vervalue = this.docVersion.toString();
      await this.validatedocument();
      if (!this.documentValidationsError.includes(true)) {
        if (this.documentEdit == false) {
         const uploadPromises = this.list.map(async (eachfiles) => {
            if (eachfiles.size == 0) {
              alert("Blank documents cannot be uploaded");
              this.loadingDocUpload = false
            } else {
              if (this.docTitle.trim() == "") {
                this.documentUploadFields.title = eachfiles.name;
              }
              if(this.documentUploadFields.owner.trim() == ""){
                this.documentUploadFields.owner = this.currentUser;
              }
              if (this.docTitle.trim() != "") {
                this.documentUploadFields.title = this.docTitle;
              }
              if (vervalue.trim() == "") {
                vervalue = "1";
              }
              const formData = new FormData();
              formData.append("DocumentId", this.docid);
              formData.append("StudyId", store.getters.getStudyIs);
              formData.append("File", eachfiles);
              formData.append("ExpiryDate", this.documentUploadFields.expiryDate);
              formData.append("ExpectedCompletionDate", this.documentUploadFields.ExpectedCompletionDate);
              formData.append("Version", vervalue ? vervalue.trim() : "");
              formData.append("VersionMessage", this.documentUploadFields.changesHistory);
                return axios.post(
                    `${this.baseurl}/etmf/document/createdocumentversion`,
                    formData,
                    {
                      headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "multipart/form-data",
                      },
                    }
                  );
            }
          })
      

            this.loadingDocUpload = true;

            try {
              await Promise.all(uploadPromises);
              alert(this.$t("navigations.documents saved successfully"))
              this.handleClose();
            }  catch (err) {
        if (err.response && err.response.data) {
          const data = err.response.data;
          if (data.messages && data.messages.length > 0) {
            alert(data.messages.join("\n"));
          } else {
            alert(data.detail || "Failed to upload one or more documents.");
          }
        } else {
          alert(err.message || "Failed to upload one or more documents.");
        }
      }
       finally {
              this.loadingDocUpload = false;
            }
        }
      }
    },

    async replaceFile (versionStr) {
      const idtoken = store.getters.getIdToken
      const formData = new FormData()

      for (let i = 0; i < this.azuredata.Document[0].length; i++) {
        formData.append('File', this.azuredata.Document[0][i])
      }
      formData.append('DocumentId', this.docid)
      formData.append('ExpiryDate', this.documentUploadFields.expiryDate || '')
      formData.append('VersionMessage', this.documentUploadFields.changesHistory || '')
      formData.append('Version', (versionStr || '1').toString())
      formData.append('StudyId', store.getters.getStudyIs)

      await axios.post(`${this.baseurl}/etmf/document/updatefile`, formData, {
        headers: {
          Authorization: 'Bearer ' + idtoken,
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    

    async fetchDocumentDetails () {
      if (!this.selectedDocument) return
      this.documentLoader = true
      const idtoken = store.getters.getIdToken
      try {
        const url = `${this.baseurl}/etmf/document/getdocumentdetails?documentId=${this.selectedDocument}${
          this.version ? `&version=${this.version}` : ''
        }`
        const { data } = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + idtoken,
            'Content-Type': 'application/json',
          },
        })

        // hydrate fields
        this.docTitle = data.documentTitle || ''
        this.docVersion = data.latestVersion || ''
        this.documentUploadFields.description = data.documentDescription || ''
        this.documentUploadFields.owner = data.owner || this.currentUser || ''
        this.documentUploadFields.expiryDate = data.expiryDate ? data.expiryDate.slice(0, 10) : ''
        this.documentUploadFields.changesHistory = data.changeHistory || ''
      } catch (e) {
        // swallow
      } finally {
        this.documentLoader = false
      }
    },
  },
}
</script>

<style scoped>
.browser-btn{
  border: 1px solid #e7eaec;
  background-color: #e7eaec;
  border-radius: 0.25rem;
}
.errorClass { color: #d9534f; font-size: 0.85rem; }
.opacity-0 { opacity: 0; }
.opacity-1 { opacity: 1; }
</style>
